module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('z-scrollDiv', {
    staticClass: "form-wrap"
  }, [_c('div', {
    staticClass: "form-item"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("申请BU：")]), _vm._v(" "), _c('div', {
    staticClass: "item-text"
  }, [_vm._v(_vm._s(_vm.data.bu_name))])]), _vm._v(" "), _c('div', {
    staticClass: "form-item"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("岗位名称：")]), _vm._v(" "), _c('div', {
    staticClass: "item-text"
  }, [_vm._v(_vm._s(_vm.data.position_name))])]), _vm._v(" "), _c('div', {
    staticClass: "form-item"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("增岗类型：")]), _vm._v(" "), _c('div', {
    staticClass: "item-text"
  }, [_vm._v(_vm._s(_vm.apply.postType[_vm.data.req_type]))])]), _vm._v(" "), _c('div', {
    staticClass: "form-item"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("增岗人数：")]), _vm._v(" "), _c('div', {
    staticClass: "item-text"
  }, [_vm._v(_vm._s(_vm.data.trans_amount))])]), _vm._v(" "), _c('div', {
    staticClass: "form-item"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("岗位需求：")]), _vm._v(" "), _c('div', {
    staticClass: "item-text"
  }, [_vm._v(_vm._s(_vm.data.position_description))])]), _vm._v(" "), _c('div', {
    staticClass: "form-item"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("申请理由：")]), _vm._v(" "), _c('div', {
    staticClass: "item-text"
  }, [_vm._v(_vm._s(_vm.data.remark))])]), _vm._v(" "), (_vm.data.status != 1) ? _c('div', {
    staticClass: "form-item"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("审核说明：")]), _vm._v(" "), _c('div', {
    staticClass: "item-text"
  }, [_vm._v(_vm._s(_vm.data.result))])]) : _vm._e(), _vm._v(" "), _c('sliderHistoty', {
    attrs: {
      "data": _vm.data.req
    }
  }), _vm._v(" "), (_vm.data.status == 1 && _vm.$route.name != 'my-application') ? _c('div', {
    directives: [{
      name: "form",
      rawName: "v-form:apply-add",
      arg: "apply-add"
    }]
  }, [_c('div', {
    staticClass: "form-line",
    attrs: {
      "text": "审核处理"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-item"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("审核说明：")]), _vm._v(" "), _c('div', {
    staticClass: "item-wrap"
  }, [_c('textarea', {
    directives: [{
      name: "arg",
      rawName: "v-arg",
      value: ('审核说明'),
      expression: "'审核说明'"
    }, {
      name: "tar",
      rawName: "v-tar",
      value: (_vm.examine.result),
      expression: "examine.result"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.examine.result),
      expression: "examine.result"
    }],
    attrs: {
      "rule": "reason",
      "placeholder": "请输入审核说明"
    },
    domProps: {
      "value": (_vm.examine.result)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.examine, "result", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.checkPass
    }
  }, [_vm._v("通 过")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.checkNotPass
    }
  }, [_vm._v("不通过")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.data.status == 3 && _vm.$route.name == 'my-application') ? _c('div', {
    directives: [{
      name: "form",
      rawName: "v-form:position-again",
      arg: "position-again"
    }]
  }, [_c('div', {
    staticClass: "form-line",
    attrs: {
      "text": "申请"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-item"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("岗位名称：")]), _vm._v(" "), _c('div', {
    staticClass: "item-text"
  }, [_c('el-select', {
    directives: [{
      name: "tar",
      rawName: "v-tar",
      value: (_vm.resub.add_positionId),
      expression: "resub.add_positionId"
    }],
    attrs: {
      "rule": "noVal",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.resub.add_positionId),
      callback: function($$v) {
        _vm.$set(_vm.resub, "add_positionId", $$v)
      },
      expression: "resub.add_positionId"
    }
  }, _vm._l((_vm.all_posts), function(item) {
    return _c('z-limitOption', {
      key: item.id,
      attrs: {
        "label": item.positionName,
        "value": item.id
      }
    })
  })), _vm._v(" "), _c('el-button', {
    staticClass: "add-post",
    attrs: {
      "icon": "plus"
    },
    on: {
      "click": function($event) {
        _vm.openEdit()
      }
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.add_inputFlag),
      expression: "add_inputFlag"
    }],
    staticClass: "add-input",
    on: {
      "mouseover": function($event) {
        _vm.add_hover = true
      },
      "mouseleave": function($event) {
        _vm.add_hover = false
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.add_editText),
      expression: "add_editText"
    }],
    ref: "post_input",
    attrs: {
      "placeholder": "请输入岗位名称"
    },
    domProps: {
      "value": (_vm.add_editText)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.uploadEdit()
      },
      "blur": function($event) {
        _vm.hideEdit()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.add_editText = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "add-btns"
  }, [_c('i', {
    staticClass: "el-icon-close",
    on: {
      "click": function($event) {
        _vm.clearEdit()
      }
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.add_up_ing),
      expression: "!add_up_ing"
    }],
    ref: "add_check",
    staticClass: "el-icon-check",
    on: {
      "click": function($event) {
        _vm.uploadEdit()
      }
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.add_up_ing),
      expression: "add_up_ing"
    }],
    staticClass: "el-icon-loading"
  })])])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-item"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("增岗类型：")]), _vm._v(" "), _c('div', {
    staticClass: "item-text"
  }, [_c('el-select', {
    directives: [{
      name: "tar",
      rawName: "v-tar",
      value: (_vm.resub.add_typeId),
      expression: "resub.add_typeId"
    }],
    attrs: {
      "rule": "noVal",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.resub.add_typeId),
      callback: function($$v) {
        _vm.$set(_vm.resub, "add_typeId", $$v)
      },
      expression: "resub.add_typeId"
    }
  }, _vm._l((_vm.apply.postType), function(val, id) {
    return _c('el-option', {
      key: id,
      attrs: {
        "label": val,
        "value": id
      }
    })
  }))], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-item"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("增岗人数：")]), _vm._v(" "), _c('div', {
    staticClass: "item-text"
  }, [_c('el-input', {
    directives: [{
      name: "tar",
      rawName: "v-tar",
      value: (_vm.resub.add_num),
      expression: "resub.add_num"
    }],
    attrs: {
      "rule": "noVal number",
      "placeholder": "请输入数字"
    },
    model: {
      value: (_vm.resub.add_num),
      callback: function($$v) {
        _vm.$set(_vm.resub, "add_num", $$v)
      },
      expression: "resub.add_num"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-item"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("岗位需求：")]), _vm._v(" "), _c('div', {
    staticClass: "item-wrap"
  }, [_c('textarea', {
    directives: [{
      name: "arg",
      rawName: "v-arg",
      value: (['岗位需求']),
      expression: "['岗位需求']"
    }, {
      name: "tar",
      rawName: "v-tar",
      value: (_vm.resub.add_require),
      expression: "resub.add_require"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.resub.add_require),
      expression: "resub.add_require"
    }],
    attrs: {
      "rule": "reason",
      "placeholder": "请输入岗位需求"
    },
    domProps: {
      "value": (_vm.resub.add_require)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.resub, "add_require", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-item"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("申请理由：")]), _vm._v(" "), _c('div', {
    staticClass: "item-wrap"
  }, [_c('textarea', {
    directives: [{
      name: "arg",
      rawName: "v-arg",
      value: (['申请理由']),
      expression: "['申请理由']"
    }, {
      name: "tar",
      rawName: "v-tar",
      value: (_vm.resub.add_reason),
      expression: "resub.add_reason"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.resub.add_reason),
      expression: "resub.add_reason"
    }],
    attrs: {
      "rule": "reason",
      "placeholder": "请输入申请理由"
    },
    domProps: {
      "value": (_vm.resub.add_reason)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.resub, "add_reason", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.subAgain
    }
  }, [_vm._v("重新提交")])], 1)]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-dd6d01d2!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/slider/sliderAdd.vue
// module id = 787
// module chunks = 1